export default angular
  .module('app.currencies')
  .constant('HoldingCurrencyCountries', {
    USD: 'us',
    CAD: 'ca',
    GBP: 'gb',
    EUR: 'eu',
    CHF: 'ch',
    JPY: 'jp',
    AUD: 'au',
    NZD: 'nz',
    HKD: 'hk',
  })
  .name;



// WEBPACK FOOTER //
// ./src/holding/modules/app/modules/currencies/constants/currency-countries.js